/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {ErrorHandler, Injectable} from '@angular/core';
import {AlertNotificationService} from './alert-notification.service';
import {AlertNotificationSeverity} from './alert-notification-severity.model';
import {environment} from '../environments/environment';

@Injectable({providedIn: 'root'})
export class ClientErrorHandler implements ErrorHandler {

    constructor(private alertService: AlertNotificationService) {
    }

    handleError(error: Error): void {
        if (environment.showErrorsOnApp) {
            this.alertService.notificationEventEmitter.emit({
                alertNotificationSeverity: AlertNotificationSeverity.ERROR,
                message: error.message,
                // Error.stack is non-standard, guarding against erroneous implementations.
                // Check: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Stack
                details: error.stack?.split?.('\n')
            });
        }

        console.error(error);
    }
}
